import React, { ComponentProps, FunctionComponent } from "react";

const FinanceIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 47 47",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M26.1229 0.00195312C22.4392 0.00195312 18.8211 0.978099 15.6356 2.82959C12.4496 4.68114 9.8118 7.34223 7.98723 10.5439C7.92912 10.6078 7.88458 10.6833 7.85746 10.7666C5.40168 11.4096 3.26544 12.9261 1.84778 15.0313C0.428136 17.1346 -0.174171 19.6853 0.151178 22.2012C0.47849 24.719 1.71024 27.0314 3.61603 28.7067C2.12861 28.819 0.834847 29.7699 0.280931 31.1547C-0.274919 32.5415 0.00784995 34.1218 1.00719 35.2297C-0.321426 36.7152 -0.321426 38.9637 1.00719 40.449C0.371961 41.1695 0.0233093 42.0972 0.0291102 43.0578C0.0291102 45.2193 1.78189 46.972 3.94326 46.972H16.9909C19.1524 46.972 20.9051 45.2192 20.9051 43.0578C20.9012 42.2889 20.6746 41.5356 20.2524 40.8925C22.1582 41.46 24.1356 41.7505 26.1228 41.7544C33.5812 41.7544 40.4739 37.7744 44.2024 31.3152C47.9325 24.8563 47.9325 16.8981 44.2024 10.4392C40.4742 3.98032 33.5813 0.00195312 26.1229 0.00195312ZM44.3904 19.573H27.4283V2.67683C31.817 2.97897 35.9483 4.85373 39.0644 7.95818C42.1787 11.0628 44.0711 15.1861 44.3904 19.573ZM2.63796 20.8783C2.63796 18.8021 3.46303 16.8092 4.93107 15.3411C6.39911 13.8731 8.39012 13.05 10.4663 13.05C12.5424 13.05 14.5334 13.8731 16.0015 15.3411C17.4695 16.8092 18.2946 18.8021 18.2946 20.8783C18.2946 22.9545 17.4695 24.9455 16.0015 26.4135C14.5334 27.8815 12.5424 28.7066 10.4663 28.7066C8.39012 28.7066 6.39911 27.8815 4.93107 26.4135C3.46303 24.9455 2.63796 22.9545 2.63796 20.8783ZM3.94332 31.3156H16.991C17.7114 31.3156 18.2944 31.9005 18.2944 32.6209C18.2944 33.3414 17.7114 33.9244 16.991 33.9244H3.94332C3.22286 33.9244 2.63796 33.3414 2.63796 32.6209C2.63796 31.9005 3.22286 31.3156 3.94332 31.3156ZM2.63796 37.8404C2.63796 37.118 3.22286 36.535 3.94332 36.535H16.991C17.7114 36.535 18.2944 37.118 18.2944 37.8404C18.2944 38.5608 17.7114 39.1438 16.991 39.1438H3.94332C3.22286 39.1438 2.63796 38.5608 2.63796 37.8404ZM16.9911 44.3632H3.94342C3.22296 44.3632 2.63806 43.7783 2.63806 43.0579C2.63806 42.3374 3.22296 41.7544 3.94342 41.7544H16.9911C17.7115 41.7544 18.2945 42.3374 18.2945 43.0579C18.2945 43.7783 17.7115 44.3632 16.9911 44.3632ZM26.1229 39.1439C24.3547 39.1361 22.598 38.8708 20.9055 38.3614C20.9172 38.1871 20.9172 38.0128 20.9055 37.8404C20.8997 36.874 20.5376 35.9444 19.8868 35.2297C20.8862 34.1219 21.1689 32.5415 20.615 31.1548C20.0592 29.77 18.7654 28.8191 17.278 28.7067C19.3581 26.8842 20.6305 24.3122 20.8164 21.5522C21.0024 18.7943 20.0843 16.0731 18.2658 13.9892C16.4491 11.9072 13.8771 10.6289 11.1192 10.4391C14.2645 5.88967 19.302 3.0119 24.8198 2.61079V20.8783C24.8198 21.2231 24.9573 21.5562 25.2014 21.8002C25.4454 22.0443 25.7785 22.1818 26.1233 22.1818H44.3908C44.0596 26.797 41.9912 31.1142 38.5998 34.2631C35.2105 37.4123 30.7498 39.1555 26.1229 39.1439Z",
    })
  );
};

const ForwardRef = React.forwardRef(FinanceIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
